
<template>
    <vue-card>
        <vue-tab :value="tabValue" type="card" @on-click="handleTab">
            <TabPane name="company-tag-type" label="标签分类"></TabPane>
            <TabPane name="company-tag-options" label="标签设置"></TabPane>
        </vue-tab>
        <div class="container">
            <div class="list-all" v-if="pageAuth===true">
                <router-view></router-view>
            </div>
        </div>
    </vue-card>
</template>

<script>
    import VueCard from "@/components/card/Card.vue";
    import VueTab from "@/components/routerTab/RouterTab.vue";
    import baseAuthEnum from "@/staticData/baseAuthEnum";
    import utils from "@/utils";
    import $api from "@/service";

    export default {
        components : {
            VueCard,
            VueTab,
        },
        data(){
            return {
                //默认选中标签
                tabValue:'',
                //权限
                pageAuth : false,
            }
        },
        created(){
            this.setTab();
            this.getAuth();
        },
        methods: {
            //获取当前router-name
            setTab(){
                let _self = this;
                this.tabValue = this.$route.name;
            },
            //tab切换
            handleTab(e){
                this.tabValue = e;
                this.$router.push({
                    name:e
                })
            },
            getAuth(){
                this.pageAuth = utils.judgeAuth([baseAuthEnum.TAB_MANAGE],1);
            }
        }
    }
</script>

<style scoped>
@import "./index.less";
</style>



// WEBPACK FOOTER //
// src/pages/company/tag/Index.vue